export default "__VITE_ASSET__ef95a1c2__"